import { Typography, styled, Avatar } from '../../../base';

export const AVATAR_SIZE = 40;

export const StyledAvatar = styled(Avatar)(({}) => ({
    height: AVATAR_SIZE,
    width: AVATAR_SIZE,
}));

export const StyledFullName = styled(Typography)(({ theme }) => ({
    fontWeight: '500',
    color: theme.palette.text.secondary,
}));

export const StyledTimeText = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    marginInline: theme.spacing(0.5),
}));

export const StyledEmailAddress = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontSize: 14,
}));

export const StyledSubject = styled(Typography)(({ theme }) => ({
    fontWeight: '500',
    color: theme.palette.text.secondary,
}));

export const StyledBody = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));
